import { render } from "./CardSkeleton.vue?vue&type=template&id=6086ccca&scoped=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&lang=js"

import "./CardSkeleton.vue?vue&type=style&index=0&id=6086ccca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6086ccca"]])

export default __exports__